import React from "react";
import { Helmet } from "react-helmet";
import moment from "moment";

const JobSchema = ({ job }) => {
  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    title: job.title,
    description: job.description.replace(/<[^>]+>/g, ''), // Remove HTML tags for better SEO
    identifier: {
      "@type": "PropertyValue",
      name: "Techtop",
      value: job.id,
    },
    datePosted: job.created_at ? moment(job.created_at).format("YYYY-MM-DD") : null,
    validThrough: null,
    employmentType: job.employment_type,
    hiringOrganization: {
      "@type": "Organization",
      name: "Techtop",
      sameAs: "https://techtopind.com/", // update if needed
      logo: "https://techtopind.com/static/media/techtop-full-logo.80ff5a4c.svg",
    },
    jobLocation: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress: job.location,
        addressLocality: null,
        addressRegion: null,
        postalCode: null,
        addressCountry: null,
      },
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: null,
      value: {
        "@type": "QuantitativeValue",
        value: job.salary,
        unitText: null, // HOUR / YEAR
      },
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default JobSchema;